
import {useLayoutEffect, useRef, useState} from 'react';


export const useRefState = function <T>(t: T|(()=>T)): [T, (t: T) => void, () => T] {

    const [state, setState] = useState(t)

    const mounted = useRef(true);
    useLayoutEffect(() => {
        return () => {
            mounted.current = false;
        }
    }, []);
    const ref = useRef({setState, state});
    ref.current = {setState, state};
    return [state, (t: T) => {
        if (mounted.current)
            ref.current.setState(t);
    }, () => {
        return ref.current.state;
    }];

}


export const xhr = (url: string, method:string = 'GET'):Promise<any> => {


    const promise = new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();

        xhr.open(method, url);
        xhr.onload = function (event) {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText,
                    event: event
                });
            }
        };
        xhr.onerror = function (error) {
            reject({
                status: this.status,
                statusText: xhr.statusText,
                event: error
            });
        };
        xhr.send();

    })
    return promise;
}


export const useForceRender = () => {

    const [state, updateState] = useState<number>(1);

    const refs = useRef<(a:number)=>void>(updateState);

    refs.current = updateState;

    return ()=>{
        refs.current(state+1);
    };


}

/*
 * General utils for managing cookies in Typescript.
 */
export function setCookie(name: string, val: string, time:number=0) {
    const date = new Date();
    const value = val;

    // Set it expire in 7 days
    if (time)
        date.setTime(date.getTime() + time * 1000);
    else
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));


    // Set it
    document.cookie = name+"="+value+"; expires="+date.toUTCString()+"; path=/; SameSite=None; Secure";
}

export function getCookie(name: string) :string|undefined{
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");

    if (parts.length == 2) {
        const d = parts.pop();
        if (d)
            return d.split(";").shift();
    }
}

export function deleteCookie(name: string) {
    const date = new Date();

    // Set it expire in -1 days
    date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));

    // Set it
    document.cookie = name+"=; expires="+date.toUTCString()+"; path=/";
}

export const makeUUID = ()=>{
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}

export const get_media = (url:string, type:string|undefined): { src:string, type: string } => {

    const what = type ? ['', type] : (url || '').match(/\.([a-zA-Z0-9]+)$/);

    if (what) {
        var o = {};

        switch (what[1]) {
            case 'ogg':
                return { src: url, 'type': 'audio/ogg'};
            case 'mp3':
                return  {src: url, type: 'audio/mpeg' };
            case 'aac':
                return { src: url, 'type': "audio/aac" };
        }
    }

    return {
        src: url,
        type: 'audio/mpeg'
    };
}
